var map = {
	"./block.svg": "f9df",
	"./colours.svg": "527e",
	"./delete.svg": "ce94",
	"./email-notifications.svg": "54ec",
	"./excel.svg": "2889",
	"./fabric.svg": "4548",
	"./faq.svg": "0775",
	"./filter.svg": "312d",
	"./icon-development.svg": "cea6",
	"./icon-download.svg": "3e4a",
	"./icon-edit.svg": "9ffd",
	"./icon-options.svg": "3e12",
	"./icon-plus.svg": "10ea",
	"./icon-production.svg": "4b2b",
	"./icon-staging.svg": "39b3",
	"./image.svg": "8591",
	"./physics.svg": "35cb",
	"./plugin.svg": "3aac",
	"./render.svg": "fd43",
	"./select.svg": "710a",
	"./star.svg": "0995",
	"./stitch.svg": "d4cf",
	"./style.svg": "48cc",
	"./sweep.svg": "8d33",
	"./text.svg": "27ba",
	"./trim.svg": "41a7",
	"./unavailable.svg": "12c5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";